module.exports = __webpack_public_path__ + "img/mimosa.812b9be5.jpg";